// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> american-landmark-preferred -> compass
// Generated: 2026-09-24T18:50:01.086Z
// Counts: 2 design, 78 content, 36 slot group, 3 collection binding, 8 section, 2 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious <span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> bedroom floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h2><h2></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore <span data-type=\"field-token\" data-field=\"property_address_city\"></span> step by step.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_icon"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "betterbot-chatbot.embed_script": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_betterbot_script"
  },
  "hyperlocal-links.show_header": {
    "overrideType": "VALUE",
    "customValue": "false",
    "generatedValue": null,
    "mappedField": null
  },
  "hyperlocal-links.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "knock-chatbot.api_token": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_knock_company_token"
  },
  "petpolicy.stat_pet_fee_sublabel": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicycallout.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pets_blurb"
  },
  "scheduleatour.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyoucontent.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_thankyou_blurb"
  },
  "accessibilityhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>At Compass, that same waterfront ease extends to the web—we're committed to making our digital experience welcoming and usable for every visitor. If you ever encounter a barrier, we're here to help.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>From a resort-inspired pool and sundeck to a 24-hour fitness center, lakefront gazebo, and lighted tennis and cricket courts, Compass keeps everyday comfort and recreation close at hand. Add in-home washers and dryers, screened outdoor space, and elevated kitchen finishes, and you'll find the details that make waterfront Melbourne living feel effortless.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Your lakefront home base at Compass is just a few clicks away—apply online today and claim your thoughtfully designed one- or two-bedroom retreat. Move into relaxed, connected Melbourne living, complete with resort-inspired amenities, screened outdoor space, and everyday comforts made for easy days.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Ready to make Compass home?</strong> Reach out to our leasing team for a tour, floor plan details, or directions to our lakefront community near Babcock Street and Palm Bay Road. Whether you're a prospective resident or already part of the neighborhood, we're here to help every step of the way.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "favoriteplaces.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Life at Compass sits right in the middle of everything that makes Melbourne, Florida special—riverfront dining, the walkable Eau Gallie Arts District, and Space Coast beaches just minutes away. Explore our list of local favorites and find your new go-to spots.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore Compass's one- and two-bedroom floor plans in Melbourne, ranging from an efficient 540-square-foot layout to a spacious two-bath home stretching past 1,000 square feet. Each plan pairs everyday comforts—full-size washer and dryer, walk-in closets, and screened outdoor space—with select finishes worth touring in person.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Get a closer look at Compass, from granite-topped kitchens with stainless steel appliances and screened patios to sunlit living rooms and comfortable bedrooms with lake views. Scroll on to explore the resort-inspired pool and sundeck, the 24-hour fitness center, resident lounge, lighted tennis courts, and the lakefront gazebo that anchors this easygoing Melbourne community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Your Melbourne map starts here.</strong> Set near Babcock Street and Palm Bay Road, Compass puts everyday errands, coffee, and quick dinners close by while keeping Florida Tech, Historic Downtown Melbourne, and the Eau Gallie Arts District within easy reach. Spend the day gallery-hopping among EGAD's murals, dining along the Indian River, catching Brevard Zoo, or heading east to the Space Coast beaches.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>At Compass, cats and dogs are welcome to settle in beside you—so your whole household feels at home from day one. With a lakefront setting for leashed strolls, a private screened patio to enjoy the breeze, and easy access to Melbourne's parks and pet services, the day-to-day here is made for four-legged company.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>At Compass, your trust matters as much as your comfort. We're committed to keeping the personal information of our visitors and residents secure, private, and handled with care.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "promopopup.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f237f-219d-70da-8731-0e8cda3b9181.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccesshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Your Compass home base, all in one place.</strong><br>Log in to the resident portal to pay rent, submit maintenance requests, and stay in the loop on community updates—anytime, from anywhere. Handle the everyday in a few taps, then get back to the lakefront calm and easy Melbourne living waiting just outside your door.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Residents consistently describe Compass as a quiet, welcoming community where a friendly leasing team and quick-responding maintenance crew make everyday life easy. From the resort-inspired pool and fitness center to the convenient Melbourne location, see why so many neighbors call it the best apartment they've lived in.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Come see waterfront living at Compass.</strong> Tour in person or virtually to take in the community lake and gazebo, resort-inspired pool, and thoughtfully designed one- and two-bedroom homes with screened outdoor space. Book your visit and discover an easy, connected home base just minutes from Downtown Melbourne and the Space Coast.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore everything Compass has to offer—from lake-view floor plans and resort-inspired amenities to our Melbourne neighborhood—all just a click away.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Thank you for reaching out to Compass.</strong> We've received your inquiry, and our leasing team will follow up with you soon—until then, imagine waterfront ease in Melbourne, with lake views, a resort-inspired pool, and a thoughtfully designed one- or two-bedroom home waiting to welcome you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a virtual walk through Compass and see the lakefront setting, resort-inspired pool, and easy everyday spaces for yourself. Explore the community at your own pace, then reach out when you're ready to make Melbourne home.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.nav_col2_link2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.alapts.com/leadership"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "footer.nav_col4_link1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.alapts.com/careers"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "footer.nav_col4_link3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://icx.efrontcloud.com/@4157/americanlandmarkfund/login.aspx"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "footer.nav_col4_link4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.alapts.com/news"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "footer.nav_col4_link5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "header.utility_link_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "scheduleatourcallout.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "custom_self_guided_tour_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "amenitieshomesection.amenity_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and palm trees."
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-3af2-7774-987d-b2411fa8deed.webp"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resort-Inspired Pool"
      }
    }
  },
  "amenitieshomesection.amenity_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center with treadmills, rowing machine, elliptical, and weight training equipment."
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-3dd7-72bc-92e2-dea3f0c502af.webp"
      },
      "title": {
        "type": "VALUE",
        "customValue": "24-Hour Fitness Center"
      }
    }
  },
  "amenitieshomesection.amenity_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Gazebo with a fountain and pond in the background, surrounded by apartment buildings."
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-02a7-7786-bbcb-0abba9db6808.webp"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Lakefront Gazebo"
      }
    }
  },
  "amenitieshomesection.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-inspired pool with sundeck seating and palm trees at Compass"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resort-Inspired Pool"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-1a97-741d-a3b8-0e02f5c9ca6d.webp"
      }
    }
  },
  "amenitieshomesection.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "24-hour strength and cardio fitness center with treadmills, spin bikes and free weights"
      },
      "title": {
        "type": "VALUE",
        "customValue": "24-Hour Fitness Center"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-194f-72a9-82b7-5cdbe19f71d9.webp"
      }
    }
  },
  "amenitieshomesection.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Lakefront gazebo overlooking the private community lake with a fountain"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Lakefront Gazebo"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-02a7-7786-bbcb-0abba9db6808.webp"
      }
    }
  },
  "amenitieslist.featured": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and palm trees."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resort-Inspired Pool & Sundeck"
      },
      "eyebrow": {
        "type": "VALUE",
        "customValue": "Featured Amenity"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-3af2-7774-987d-b2411fa8deed.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "<p>Cool off in the resort-inspired pool, then settle into a sundeck lounge chair framed by palm trees and lush landscaping. It's the community's go-to spot for a midday swim or an easy afternoon under the Florida sun—just steps from home.</p>"
      }
    }
  },
  "amenitieslist.in_home_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5717049565249536/019d02f2-a92b-72ed-abe8-5a721e965e7a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen and living area with granite countertops, stainless steel appliances, and wood-look flooring."
      }
    }
  },
  "favoriteplaces.place_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-3409-7228-ba80-97d61e560870.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Ember & Oak"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Ember & Oak"
      },
      "url": {
        "type": "VALUE",
        "customValue": "http://emberandoak.com/"
      }
    }
  },
  "favoriteplaces.place_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-35fb-771b-9003-046276453d78.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Chart House"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Chart House"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://www.chart-house.com/location/chart-house-melbourne-fl/"
      }
    }
  },
  "favoriteplaces.place_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019f150e-c4f6-7697-a412-dc928c4c76fc.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Brevard Zoo"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Brevard Zoo"
      },
      "url": {
        "type": "VALUE",
        "customValue": "http://www.brevardzoo.org/"
      }
    }
  },
  "homefeaturessplit.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-1973-772c-8dc3-c557afe5b035.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Comfortable seating area with a sofa, chairs, coffee table, and TV, adjacent to a business center with computers."
      }
    }
  },
  "homegallerygrid.gallery_image_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-3ef8-73bd-83ec-bf18ae1195e5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with granite countertops, stainless steel appliances, and a large sink."
      }
    }
  },
  "homegallerygrid.gallery_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-1d28-727a-aca3-771c06812bbe.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "King size bed in a modern bedroom with a large window and a ceiling fan."
      }
    }
  },
  "homegallerygrid.gallery_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-1b45-73fa-8308-3d6d716236aa.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of apartment buildings with a sidewalk and grassy lawn."
      }
    }
  },
  "homeintrosection.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-3b76-746e-8588-5cf643095a5f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room with gray sofa, green accent chair, glass coffee table, and TV console."
      }
    }
  },
  "interiorintro.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5717049565249536/019d02f2-a92b-72ed-abe8-5a721e965e7a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Open-concept model home at Compass with granite countertops, stainless steel appliances, and wood-style flooring flowing from the kitchen into the living area."
      }
    }
  },
  "neighborhoodctahomesection.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5717049565249536/019d02f2-949b-76da-9854-522989d09b83.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a suburban neighborhood with apartment buildings, ponds, and a go-kart track."
      }
    }
  },
  "neighborhoodhomesection.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5717049565249536/019d02f2-90d0-71fe-b4d7-fba9f548c0fa.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of apartment buildings and surrounding neighborhood with a pool and water features."
      }
    }
  },
  "pageblurb.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-02a7-7786-bbcb-0abba9db6808.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Lakefront gazebo with a fountain and pond, framed by Compass's apartment buildings."
      }
    }
  },
  "pageblurb.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-3af2-7774-987d-b2411fa8deed.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and palm trees."
      }
    }
  },
  "pageblurb.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-1b45-73fa-8308-3d6d716236aa.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of the Compass community buildings with a winding sidewalk and green lawn."
      }
    }
  },
  "residentaccess.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-1b45-73fa-8308-3d6d716236aa.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of Compass apartment buildings with a sidewalk winding through a green lawn"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Make a Payment"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://americancompass.loftliving.com/login"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "residentaccess.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-3b76-746e-8588-5cf643095a5f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Furnished living room with a gray sofa, green accent chair, glass coffee table, and TV console"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resident Portal"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://americancompass.loftliving.com/login"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "residentaccess.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5717049565249536/019e898e-02a7-7786-bbcb-0abba9db6808.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Lakefront gazebo overlooking a tranquil pond with a fountain, framed by the community grounds"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Contact Us"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/contact"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_self"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      61
    ],
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "betterbot-chatbot",
      "blockId": "betterbot-chatbot",
      "position": 0
    },
    {
      "sectionId": "knock-chatbot",
      "blockId": "knock-chatbot",
      "position": 0
    },
    {
      "sectionId": "leasing-ai-pixel",
      "blockId": "leasing-ai-pixel",
      "position": 0
    }
  ],
  "home": [
    {
      "sectionId": "hyperlocal-links",
      "blockId": "hyperlocal-links",
      "position": 17
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  },
  "neighborhoodmap.category_order": {
    "properties": {
      "textAlign": "center"
    }
  }
};
